
<template>
  <v-app>
    <v-overlay
      :absolute="false"
      :opacity="0.45"
      :value="show_loader"
      :z-index="3939938498494989"
    >
      <v-skeleton-loader
        :loading="show_loader"
        :transition="'scale-transition'"
        height="94"
        width="350"
        type="list-item"
        class="loader"
      ></v-skeleton-loader>
    </v-overlay> 
    <div id="mapid" style="height: 100%; width: 100%;"></div>
  </v-app>
</template>

<style>
#dashboard {
  background: #eee !important;
}

.loader {
  opacity: 1;
  z-index: 883787867879778787;
}

#mapid {
  position: relative;
  height: 100% !important;
  z-index: 0;
}


</style>

<script>
import kensrin_map from "../mixins/kensrin_map";
import common from "../mixins/common";
import { mapMutations, mapState } from "vuex";
import { getGroupedAssets } from "@/services/assetsDb";

export default {
  name: "Maps",
  components: {
    pageloader: false 
  },
  data() {
    return { 
      asset_groups: [],
      all_assets: [],
      // True once the map has read the asset cache at least once.
      assets_read: false,
    };
  },
  async mounted() {  
    await this.refreshAssets();
  },

  mixins: [common,kensrin_map], 

  computed: {
    ...mapState([
      "notification",
      "session",
      "objects_loaded",
      "selected_object",
      "selected_group",
      "assets_version"
    ]),
    // Hide the skeleton only when the assets are cached AND the map has read
    // them, otherwise it disappears before the markers appear on first login.
    show_loader() {
      return !this.objects_loaded || !this.assets_read;
    }
  },

  methods: { 
    // Read the freshest assets from the IndexedDB cache (written by the central
    // poller in Platform) and expose the selected group's children to the map.
    async refreshAssets() {
      try {
        const groups = await getGroupedAssets(this.session.account[0].username);
        this.all_assets = groups;
        const current = groups.find(g => g.text === this.selected_group) || groups[0];
        this.asset_groups = current ? (current.children || []) : [];
      } finally {
        // Mark read even when there are no assets, so the loader can clear.
        this.assets_read = true;
      }
    },
  }, 
  watch: {
    selected_group(newGroup) {
      if(this.all_assets.length > 0) {
        this.asset_groups = this.all_assets.find(g => g.text === newGroup)?.children || [];
      }
    }, 
    // The central poller bumps this after every successful /objects sync, so the
    // map re-reads the cache and moves the markers instead of staying frozen.
    assets_version() {
      this.refreshAssets();
    },
    // When the first load completes (objects_loaded flips true) the cache has
    // just been populated; require a fresh read before clearing the skeleton.
    objects_loaded(value) {
      if (value) this.assets_read = false;
    },
  }
};
</script>
